var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExecutedBeerBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "16px",
    viewBox: "0 0 7 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B89F454F-73D8-4B80-A761-BE16B0573A79") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Supply-Analytics-Overview---GMSupply",
    transform: "translate(-171.000000, -207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layout",
    transform: "translate(154.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rows",
    transform: "translate(15.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "exectued-beer-icon",
    transform: "translate(2.500000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.23422416,0 L3.46947954,0 C3.74468978,1.93880496e-16 3.97757851,0.203324797 4.01471213,0.476018345 L4.05964201,0.805964309 C4.07707382,0.933976094 4.03688222,1.06313147 3.94989107,1.15864809 C3.86233569,1.25478423 3.81857039,1.38292584 3.82902468,1.51253606 L4.02184064,3.9030308 C4.06416401,4.42774779 4.28035447,4.92334251 4.63616558,5.31130853 C4.98928252,5.69633691 5.18518519,6.19978065 5.18518519,6.72221574 L5.18518519,12.6560847 C5.18518519,13.1119387 4.81564244,13.4814815 4.35978836,13.4814815 L1.34391534,13.4814815 C0.888061265,13.4814815 0.518518519,13.1119387 0.518518519,12.6560847 L0.518518519,6.72221574 C0.518518519,6.19978065 0.714421182,5.69633691 1.06753813,5.31130853 C1.42334924,4.92334251 1.63953969,4.42774779 1.68186307,3.9030308 L1.87467903,1.51253606 C1.88513332,1.38292584 1.84136801,1.25478423 1.75381264,1.15864809 C1.66682148,1.06313147 1.62662988,0.933976094 1.64406169,0.805964309 L1.68899157,0.476018345 C1.7261252,0.203324797 1.95901392,1.61577604e-16 2.23422416,0 Z",
    id: "beer",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26614944,3.55678434 L5.39499612,6.22222222 L5.39499612,6.22222222 L5.20830479,12.695168 C5.19542976,13.1415697 4.82983842,13.4967688 4.38325105,13.4967688 L1.31502286,13.4967688 C0.870609877,13.4967688 0.505978214,13.1449008 0.490149725,12.7007698 L0.264639397,6.37318331 C0.261082276,6.27487215 0.285615398,6.17759055 0.335321622,6.09269635 C1.14120998,4.71630447 1.54415416,3.89528222 1.54415416,3.62962963 C1.54415416,3.35574681 1.825969,3.36084257 2.38959866,3.64491693 L3.63694462,3.26317768 C3.8909224,3.18545002 4.16256851,3.3122086 4.26614944,3.55678434 Z",
    id: "beer",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#404040",
    strokeWidth: 0.5,
    cx: 3.54439371,
    cy: 8.34601725,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#404040",
    strokeWidth: 0.5,
    cx: 2.05276509,
    cy: 7.28056824,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2962963,3.20684392 C1.88038319,3.20684392 2.33733262,4.12639841 3.19222099,4.12639841 C4.04710936,4.12639841 4.41787835,3.5813715 4.27313653,3.37321068",
    id: "Path-12",
    stroke: "#404040",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7841405,-0.452764503 L4.39478855,3.86212696 C4.42829377,4.30761762 4.61071733,4.72874952 4.91253607,5.05784384 C5.32908927,5.51204126 5.56018519,6.10592695 5.56018519,6.72221574 L5.56018519,6.72221574 L5.56018519,12.6560847 C5.56018519,12.9875651 5.42582619,13.2876643 5.2085971,13.5048934 C4.991368,13.7221225 4.69126879,13.8564815 4.35978836,13.8564815 L4.35978836,13.8564815 L1.34391534,13.8564815 C1.01243491,13.8564815 0.712335707,13.7221225 0.495106609,13.5048934 C0.27787751,13.2876643 0.143518519,12.9875651 0.143518519,12.6560847 L0.143518519,12.6560847 L0.143518519,6.72221574 C0.143518519,6.10592695 0.374614432,5.51204126 0.791167638,5.05784384 C1.09055659,4.73139889 1.272465,4.31439228 1.30807701,3.87288143 L1.30807701,3.87288143 L1.49799608,1.5183018 C1.40150521,0.638389551 1.47866698,0.219959845 1.59746012,0.0259323237 L1.59746012,0.0259323237 L3.7841405,-0.452764503 Z",
    id: "beer",
    stroke: "#404040",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutedBeerBottle);
export default __webpack_public_path__ + "static/media/executed-beer-bottle.de2bdb58d453dbc26b7d153dd7ca0c20.svg";
export { ForwardRef as ReactComponent };